/** Automatisch importierte Termine (Stundenplan, fussball.de, LADV): kein „eingetragen von …“, Herkunft statt Person. */
export const IMPORTED_SOURCES: ReadonlySet<string> = new Set(["web_untis", "fussball_de", "ladv"]);

export const isImportedSource = (source: string | null | undefined): boolean => source != null && IMPORTED_SOURCES.has(source);

export function importedSourceLabel(source: string | null | undefined): string | null {
  if (source === "web_untis") return "Stundenplan";
  if (source === "fussball_de") return "fussball.de";
  if (source === "ladv") return "LADV";
  return null;
}
